import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./assets/styles/app.scss";
import "./index.css";
import { LocalizationProvider, preloadLocalization } from "./stores/localizationContext.tsx";

async function start() {
  await preloadLocalization();
  createRoot(document.getElementById("root")!).render(
    <LocalizationProvider>
      <App />
    </LocalizationProvider>
  );
}

start();